import React from 'react';
import { motion } from 'framer-motion';
import { Instagram, ArrowUpRight } from 'lucide-react';

export default function SocialSection() {
  return (
    <section data-testid="social-section" className="py-16 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="flex flex-col sm:flex-row items-center justify-between gap-6 p-8 sm:p-10 border border-gray-100 bg-[#F4F8F4]"
        >
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 bg-gradient-to-br from-[#2D5A27] to-[#10B981] rounded-lg flex items-center justify-center">
              <Instagram className="w-7 h-7 text-white" strokeWidth={1.5} />
            </div>
            <div>
              <h3 className="font-['Outfit'] text-xl font-bold text-[#1A3A22]">
                Folgen Sie unserer elektrisierenden Journey
              </h3>
              <p className="font-['Manrope'] text-gray-500 text-sm">
                Entdecken Sie aktuelle Projekte, Einblicke hinter die Kulissen und erfahren Sie, wie wir Bonner Immobilien mit Strom versorgen.
              </p>
            </div>
          </div>
          <a
            href="https://www.instagram.com/elektro.daniels/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="instagram-link"
            className="inline-flex items-center gap-2 bg-[#2D5A27] hover:bg-[#10B981] text-white px-8 py-3 font-['Outfit'] font-semibold text-sm tracking-[0.1em] uppercase transition-all duration-300 hover:-translate-y-0.5 flex-shrink-0"
          >
            @elektro.daniels
            <ArrowUpRight className="w-4 h-4" />
          </a>
        </motion.div>
      </div>
    </section>
  );
}
